<template>
  <div
    :style="{ top: $route.name == 'store' ? '80px' : '20px', position:'sticky' }"
  >
    <div class="bg-white">
      <div>
        <div v-if="cartItems.length > 0" class="container-fluid p-0">
          <div class="row shopping-cart-clearall">
            <div class="col-md-6">
              <h3 class="text-gray">Order</h3>
            </div>
            <div class="btn col-md-6 text-right">
              <a @click="clearAllOrders()" :style="desktopStyles.LinkColorTxt">Clear all</a>
            </div>
          </div>
          <hr class="m-0" />
        </div>
        <div class="container">
          <div class="row cart-items wholeOrderDiscount" v-if="wholeOrderDiscount">
            <div
              :style="desktopStyles.successMsg"
              class="discount-container"
            >{{wholeOrderDiscountMessage}}</div>
          </div>
        </div>
        <div v-if="cartItems.length > 0" class="cart-items-wrapper">
          <div class="container">
            <template v-for="(item, index) in cartItems">
              <cart-item
                :cart-item="item"
                :key="index"
                :index="index"
              />
            </template>
          </div>

          <hr v-if="cartItems.length > 0" />
          <div class="container price-container" v-show="cartItems.length > 0">
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">
                  Subtotal
                  <small class="fw-600">({{ cartLength }} items)</small>
                </div>
                <div class="cart-subtotal-cost">{{ subtotalPrice | formatMoney }}</div>
              </div>
            </div>
            <div v-if="showDelivery" class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">Delivery</div>
                <div class="cart-subtotal-cost">{{ deliveryFee | formatMoney }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">GST</div>
                <div class="cart-subtotal-cost">{{ totaltax | formatMoney }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">Discount</div>
                <div class="cart-subtotal-cost">{{ discount | formatMoney }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'" />
      <div v-if="canshowRedemption" class="container">
        <div class="row pt-4">
          <div @click="addReedemption()" class="col-sm-12 checkout">
            <a
              class="btn redeem-btn btn-lg btn-block mb-2"
            >Redeem Stamps: {{ canshowRedemption.Name }}</a>
          </div>
        </div>
      </div>
      <div
        class="container"
        v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'"
      >
        <div class="row">
          <CouponComponent ref="couponComponent" :className="'cart-totals'"></CouponComponent>
        </div>
      </div>
      <hr v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'" />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="total">Total (Inc GST)</div>
            <!--  :class="(getStamps || getPoints)?'has-point':''"
              <div v-if="getStamps || getPoints" class="row cost has-point">
              <div class="col-md-6">{{ totalPrice | formatMoney }}</div>
              <div
                class="points"
                :class="getStamps?'text-danger':'text-success'"
              >({{ getStamps?getStamps :getPoints| formatNumber }}{{getStamps?' stamps':' pts'}})</div>
            </div> v-if="(getStamps && getPoint)"-->
            <div class="cost">{{ totalPrice | formatMoney }}</div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="orderMode"
              :disabled="orderDisbaled"
              type="submit"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
              :style="desktopStyles.btn"
            >
              Place Order
              <span v-show="proccessing">
                <i class="spin ml-4" />
              </span>
            </button>
            <router-link
              v-else
              :to="{ name: 'checkout', params: {storeid: $route.params.storeid, storename: $route.params.storename } }"
              :class="{
                disabled:
                  cartItems.length === 0 || storeClosed === true
                    ? 'disabled'
                    : ''
              }"
              class="btn btn-primary btn-lg btn-block shadow mb-2"
              :style="desktopStyles.btn"
            >{{ storeClosed ? "Store closed" : "Checkout" }}</router-link>
            <div v-show="storeClosed" class="pt-1" v-html="store.ClosingStoreMessage" />
            <div
              v-show="!exceedMinPurchase && orderMode && !storeClosed"
              class="color-red pt-1 text-center fs-90"
            >Minimum purchase is {{ minPurchase | formatMoney }}</div>
            <div
              v-show="IsInOperationMessage && !store.IsInOperation"
              class="p-2 color-red text-center fs-90"
            >{{IsInOperationMessage}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >Continue Ordering</button>
    </div>
    <poweredby v-if="!isBranded()" />

    <modal ref="redemptionModal" v-if="showRedemption" full-header @close="closeModal" hide-footer>
      <template slot="body">
        <div>
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import CartItem from "./CartItem";
import { getStore } from "../../../api/services/storeService.js";
import { IsStoreOpenAtTime } from "./../../../api/helpers/datetimeHelper.js";
import * as moment from "moment";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
import uuid from "uuid/v1";
import modal from "../../modal";
import Modifiers from "../products/Modifiers";

import {
  priceTriggerType,
  OutcomePriceType
} from "../../../api/constants/priceTriggerEnums";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      IsInOperationMessage: null,
      store: {},
      storeClosed: false,
      timerId: null,
      minPurchase: 0,
      selectedReedemption: null,
      showRedemption: false
    };
  },
  computed: {
    ...mapGetters([
      "priceTriggerOutcomes",
      "cartValue",
      "cartItems",
      "totaltax",
      "getIsDelivery",
      "discount",
      "getTotalPrice",
      "deliveryFee",
      "getSelectedTriggerCheckOutPage",
      "getTriggerCheckOutPage",
      "desktopStyles",
      "applicableLoyalityRule",
      "canshowRedemption",
      "StoreMenu",
      "getProductInCategoryInfo",
      "useStampCollection",
      "reedemptionPoints"
    ]),
    menuCopy() {
      return JSON.parse(JSON.stringify(this.StoreMenu));
    },
    getStamps() {
      if (this.useStampCollection) return this.reedemptionPoints;
      else return null;
    },
    getPoints() {
      if (this.getStamps != null) return null;
      if (this.applicableLoyalityRule)
        return Math.round(
          this.totalPrice * this.applicableLoyalityRule.pointPerDollar
        );
      else return null;
    },
    wholeOrderDiscount() {
      var res = this.priceTriggerOutcomes.find(
        pt => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
      );
      return res;
    },
    wholeOrderDiscountMessage() {
      var res = this.wholeOrderDiscount;
      if (res) {
        switch (res.OutcomePriceType) {
          case OutcomePriceType.OutcomePriceType_PercentageDiscount:
            return `This order will be discounted ${res.DiscountPercentageValue *
              100}%`;
          case OutcomePriceType.DiscountFlatValue:
            return `This order will be discounted ${
              res.DiscountPercentageValue
            }%`;
          default:
            return "";
        }
      }
      return "";
    },
    cartLength() {
      let sum = 0;
      this.cartItems.forEach(element => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    totalPrice() {
      return this.getTotalPrice;
    },

    subtotalPrice() {
      return this.cartValue;
    },
    showDelivery() {
      return this.getIsDelivery;
    },
    exceedMinPurchase() {
      return this.subtotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return moment()
        .set({ hour: 10, minute: 0, second: 0 })
        .utc();
    },

    now() {
      return moment.utc();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        (this.cartItems.length === 0 ||
          this.storeClosed === true ||
          !this.store.IsInOperation)
      );
    }
  },
  watch: {
    store(newValue) {
      this.storeClosed = !IsStoreOpenAtTime(newValue, moment());
      // this.storeClosed =
      //   IsClosedTimeOfStore(newValue) || !newValue.IsInOperation;

      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    subtotalPrice(newValue) {
      this.initDeliveryInfo(newValue);
    },
    cartItems: {
      handler: function(newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          that.IsInOperationMessage = "Store is not in operation.";
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
          that.initDeliveryInfo(0);
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  }, updated() {
    var elem = document.querySelector("#uniquemodal");
    if (elem) {
      elem.parentNode.removeChild(elem);
      var cart = document.querySelector("#shopping-cart");
      cart.appendChild(elem);
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },

  methods: {
    ...mapMutations(["REMOVE_CART_ITEM", "setDeliveryFee", "Add_ProductItem"]),
    ...mapActions([
      "insertErrorlog",
      "redirectToErrorPage",
      "applyPriceTriggers",
      "fixRedemptionQuantity"
    ]),
  
    applyCoupon(code) {
      this.$refs.couponComponent.applyCoupon(code);
    },
    selectTriggerCheckOutPageEvent(value) {
      this.setSelectedTriggerCheckOutPage(value);
      this.$forceUpdate();
    },

    continueOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    clearAllOrders() {
      this.cartItems.forEach(cartitem => {
        this.REMOVE_CART_ITEM({ item: cartitem });
        this.applyPriceTriggers();
      });
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime)) {
        this.cartItems.forEach(element => {
          let createdTime = moment(element.created).utc();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_CART_ITEM({ item: element });
            this.applyPriceTriggers();
          }
        });
      }
    },
    initDeliveryInfo(value) {
      //delivery fee
      if (value == 0) {
        value = this.subtotalPrice;
      }
      let _deliveryFee = 0;
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            value > rule.PriceRangeMinimum &&
            value < rule.PriceRangeMaximum
          ) {
            _deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }
      this.setDeliveryFee(_deliveryFee);
    },
    computeRules() {
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },
    addReedemption() {
      var product = this.menuCopy.Products[
        this.canshowRedemption.ProductVariant
      ];
      if (product.ModifierGroups && product.ModifierGroups.length > 0) {
        this.selectedReedemption = {
          product: product,
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.canshowRedemption.ProductVariant.toString()
        };
        this.showRedemption = true;
      } else {
        this.confirmReedemption(product);
      }
    },
    closeModal() {
      this.$refs.redemptionModal.hideModal();
      this.showRedemption = false;
    },
    selectRollIntoModiefiers(modifiers) {
      if (this.selectedReedemption) {
        this.confirmReedemption(this.selectedReedemption.product, modifiers);
        this.selectedReedemption = null;
        this.$refs.redemptionModal.hideModal();
        this.showRedemption = false;
        return;
      }
    },
    confirmReedemption(product, modifiers = []) {
      var productInfo = this.getProductInCategoryInfo(
        this.canshowRedemption.ProductVariant
      );
      var newPrice =
        productInfo.Price -
        productInfo.Price * (this.canshowRedemption.DiscountRate / 100);
      this.Add_ProductItem({
        item: {
          id: this.canshowRedemption.ProductVariant,
          uniqueId: uuid(),
          itemNote: "",
          code: product.ProductCode,
          name: product.Name,
          description: product.ShortDescription,
          photoUrl: product.PhotoUrl,
          tax: product.TaxRate,
          price: newPrice,
          reedemptionRule: this.canshowRedemption
        },
        quantity: 1,
        ProductCategoryIDs: product.ProductCategoryIDs,
        ProductTagIDs: product.ProductTagIDs,
        modifiers: modifiers
      });
      this.applyPriceTriggers();
    }
  }
};
</script>
